module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABT0lEQVQ4T5WSPUvDYBSFz0mhiYtOgkOhHSK4KKFD/4WLIIKbk4uDs67W2cHFyU0QwaX/okOb1EUwQwsdBKc62KTQHHmDb4nBz0yXc89z70lyicLT6/VWK5XKsaRtkuumJemJZGc+n180m80Xa6ctwjDckXRNcrk4zNaSXkkeBEFwb7QcNBCAOwDOV1BBywDsGpgmHsn4u03lQWazJJ9RFLUlnViD7/sYj8dIkiSXPM9DrVZDHMeLGSTPDTiQtGlVY6zX6xiNRrlkazvow/dgwKkkrxjJwkYzA0oQSCYMw/ANwFIRdF0XjUYjl4bDIdI0Lb/qlP1+PyK5ZTsWKkYtw5IGJuqZpNN/fpw2u93uWrVafQSw8ss/tO3JbDbbsAewB+DmjwewHwTBbfHkDHz1w+YJgEMDLU7OZjCxXdc9yrLs05E7jtNJ0/Sy1Wo9W+87TDaoQxQe6GkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/label-close.png
// module id = yl1g
// module chunks = 140